 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      // CM perf 2026-10 (INP): antes observaba también atributos (abrir/cerrar el drawer disparaba la recarga) y
      // parseaba la página completa con DOMParser (700 KB en PDP) en el hilo principal. Ahora: solo cambios de
      // contenido del carrito, se ignoran mutaciones del propio bloque de upsell/timer, y se parsea solo el fragmento
      // entre los marcadores <!--cm-upsell-start/end--> (cart-drawer.liquid), con fallback al método anterior.
      if (!document.querySelector('#cart-drawer-upsell-wrapper')) return
      const ignore = (n) => n && n.nodeType === 1 && n.closest && n.closest('#cart-drawer-upsell, #cart-timer, .cart-drawer-upsell-list')
      const observer = new MutationObserver((mutations) => { 
        if (mutations.every((m) => ignore(m.target))) return
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          let fresh = null
          const a = text.indexOf('<!--cm-upsell-start-->'), b = text.indexOf('<!--cm-upsell-end-->')
          if (a > -1 && b > a) {
            const tpl = document.createElement('template')
            tpl.innerHTML = text.slice(a + 22, b)
            fresh = tpl.content.querySelector('#cart-drawer-upsell-wrapper')
          } else {
            fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('#cart-drawer-upsell-wrapper')
          }
          const current = document.querySelector('#cart-drawer-upsell-wrapper')
          if (current && fresh) current.replaceWith(fresh)
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();